// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 996) return "js/996.js";
	if (chunkId === 928) return "js/928.js";
	// return url for filenames based on template
	return undefined;
};